module.exports = __webpack_public_path__ + "x4.no2.2fca6e6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x4.no2.jpg
// module id = FTNI
// module chunks = 0